import { useCallback } from 'react';

import { api } from '@shared/api';
import { TimesEnum } from '@shared/enums';

import { useQuery } from '@tanstack/react-query';

type Props = {
  jobUuid?: string;
};

const useFetchMarginTransactionReportsJob = ({ jobUuid }: Props) => {
  const fetchTransactionReportJob = useCallback(async () => {
    if (!jobUuid) return undefined;

    const response = await api.endpoints.getMarginTransactionReportJob({ params: { jobUuid } });
    return response.data;
  }, [jobUuid]);

  return useQuery({
    queryKey: ['margin-transaction-reports', jobUuid],
    queryFn: fetchTransactionReportJob,
    keepPreviousData: true,
    networkMode: 'always',
    refetchIntervalInBackground: true,
    refetchInterval: (data) => {
      if (!data || data?.status !== 'COMPLETED') return TimesEnum.SECOND;
      return false;
    },
    enabled: jobUuid !== undefined,
  });
};

export { useFetchMarginTransactionReportsJob };
